import type { ComponentProps } from "react";

import { UNIT_SYSTEM, WEIGHT_UNIT } from "@/shared/models";
import { useSettingsStore } from "@/shared/stores";
import { Switch } from "@/shared/ui/common";
import { tw } from "@/shared/utils";

type UnitSystemSwitchProps = Omit<
  ComponentProps<typeof Switch>,
  "checked" | "onCheckedChange" | "leftLabel" | "rightLabel"
>;

export const UnitSystemSwitch = ({
  className,
  ...props
}: UnitSystemSwitchProps) => {
  const unitSystem = useSettingsStore((state) => state.unitSystem);
  const setUnitSystem = useSettingsStore((state) => state.setUnitSystem);

  const handleOnCheckedChange = (checked: boolean) => {
    setUnitSystem(checked ? UNIT_SYSTEM.METRIC : UNIT_SYSTEM.IMPERIAL);
  };

  return (
    <Switch
      checked={unitSystem === UNIT_SYSTEM.METRIC}
      onCheckedChange={handleOnCheckedChange}
      leftLabel={WEIGHT_UNIT[UNIT_SYSTEM.IMPERIAL]}
      rightLabel={WEIGHT_UNIT[UNIT_SYSTEM.METRIC]}
      className={tw("uppercase", className)}
      {...props}
    />
  );
};
